import { useLocation } from "@tanstack/react-router";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useSession } from "@/lib/auth-client";

export const PostHogPageViewTracker = () => {
  const location = useLocation();
  const posthog = usePostHog();
  const { data: session } = useSession();
  const accountId = session?.user?.accountId;
  const pathname = location.pathname;

  // Identify the user
  // keeping all events for the same user linked in PostHog.
  useEffect(() => {
    if (!(accountId && posthog)) {
      return;
    }

    posthog.identify(accountId);
  }, [accountId, posthog]);

  useEffect(() => {
    if (!posthog) {
      return;
    }

    posthog.capture("$pageview", {
      $current_url: pathname,
    });

    return () => {
      posthog.capture("$pageleave", {
        $current_url: pathname,
      });
    };
  }, [pathname, posthog]);

  return null;
};
